import { appLinkConfig } from '../constants/appLinks';

export function getAppLinkTarget(platform) {
  if (platform === 'ios') {
    return {
      openUrl: appLinkConfig.iosDeepLink,
      storeUrl: appLinkConfig.iosStoreUrl,
    };
  }

  if (platform === 'android') {
    return {
      openUrl: buildAndroidIntentUrl(
        appLinkConfig.androidDeepLink,
        appLinkConfig.androidStoreUrl,
        appLinkConfig.androidPackageName,
      ),
      storeUrl: appLinkConfig.androidStoreUrl,
    };
  }

  return null;
}

export function openAppWithStoreFallback(target, onFallback) {
  let didLeavePage = false;

  const markPageLeft = () => {
    didLeavePage = true;
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      markPageLeft();
    }
  };

  window.addEventListener('pagehide', markPageLeft);
  window.addEventListener('blur', markPageLeft);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  const fallbackTimer = window.setTimeout(() => {
    if (!didLeavePage) {
      onFallback();
      window.location.href = target.storeUrl;
    }
  }, appLinkConfig.fallbackDelayMs);

  window.location.href = target.openUrl;

  return () => {
    window.clearTimeout(fallbackTimer);
    window.removeEventListener('pagehide', markPageLeft);
    window.removeEventListener('blur', markPageLeft);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}

export function buildAndroidIntentUrl(deepLink, fallbackUrl, packageName) {
  try {
    const parsed = new URL(deepLink);
    const scheme = parsed.protocol.replace(':', '');
    const path = `${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
    const packageOption = packageName ? `package=${packageName};` : '';

    return `intent://${path}#Intent;scheme=${scheme};${packageOption}S.browser_fallback_url=${encodeURIComponent(
      fallbackUrl,
    )};end`;
  } catch {
    return deepLink;
  }
}

export function detectPlatform() {
  const userAgent = window.navigator.userAgent || '';
  const platform = window.navigator.platform || '';
  const maxTouchPoints = window.navigator.maxTouchPoints || 0;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/ipad|iphone|ipod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)) {
    return 'ios';
  }

  return 'desktop';
}
